// extracted by mini-css-extract-plugin
export var copyIcon = "_sc-2";
export var discountCard = "_sc-0";
export var discountCode = "_sc-3";
export var discountContent = "_sc-1";
export var loadingCard = "_sc-4";